import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import useFetchData from "../../../../../hooks/useFetchData";
import { DEFAULT_HYDROGEOLOGY_STATE } from "../constants";
import { useStateIfMounted } from "use-state-if-mounted";

export const useHydrogeology = (selectedWell) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_HYDROGEOLOGY_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedWell) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_HYDROGEOLOGY_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["list-wells-hydrogeology", selectedWell],
    async () => {
      if (!selectedWell) {
        setIsDirty(false);
        setEditorState(DEFAULT_HYDROGEOLOGY_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/list-wells-hydrogeology/${selectedWell}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [aquiferCompletionLookup] = useFetchData(
    "ui-list-wm-aquifer-completion",
    [],
    true
  );
  const [aquiferProductionZoneLookup] = useFetchData(
    "ui-list-wm-aquifer-production-zone",
    [],
    true
  );
  const [aquiferSettingLookup] = useFetchData(
    "ui-list-wm-aquifer-setting",
    [],
    true
  );
  const [watershedLookup] = useFetchData("ui-list-wm-watershed", [], true);
  const [formationLookup] = useFetchData("ui-list-wm-formation", [], true);
  const [logTypesLookup] = useFetchData("list-well-log-types", [], true);

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {
      aquiferCompletion: aquiferCompletionLookup,
      aquiferProductionZone: aquiferProductionZoneLookup,
      aquiferSetting: aquiferSettingLookup,
      watershed: watershedLookup,
      surfaceGeology: formationLookup,
      logTypes: logTypesLookup,
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
